import { ReactNode, useMemo } from "react";
import { FootnoteContext, Footnote } from "@utils/FootnoteContext";
import { FootnoteEntry } from "@utils/extractPageFootnotes";

export const FootnoteProvider = ({
  footnoteEntries,
  children,
}: {
  footnoteEntries: FootnoteEntry[];
  children: ReactNode;
}) => {
  const value = useMemo(() => {
    const footnotes: Footnote[] = footnoteEntries.map((entry, i) => ({
      id: entry.id,
      number: i + 1,
      value: entry.value,
    }));
    const map = new Map(footnotes.map((f) => [f.id, f.number]));
    return {
      footnotes,
      getNumber: (id: string) => map.get(id) ?? null,
    };
  }, [footnoteEntries]);

  return (
    <FootnoteContext.Provider value={value}>
      {children}
    </FootnoteContext.Provider>
  );
};
